export { HorizontalScroll } from './HorizontalScroll';
export { HorizontalScrollProps } from './HorizontalScroll.types';
